import React, { startTransition, useEffect, useState } from "react";
import { Icon as Iconify } from "@iconify/react";
import NuevoItem from "./nuevoItem/NuevoItem";
import useAnimationSettings from "../../hooks/useAnimationSettings";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

const proyectos = [
  {
    titulo: "Optimización crítica de plataforma educativa",
    desc: "Reestructuré la base de datos y reconstruí la app de cursos para soportar más de 50.000 estudiantes, bajando requests de 50M a cerca de 100k por día y memoria de 12 GB a 500 MB.",
    img: "https://i.imgur.com/UpiS77J.png",
    url: "",
    tecnologias: ["Next.js", "Arquitectura de datos", "Tailwind", "Git", "Vercel"],
  },

  {
    titulo: "Sistema operativo para restaurantes",
    desc: "Producto full stack para gestionar pedidos, promociones, clientes y notificaciones en tiempo real, con foco en operación diaria, performance y mantenimiento.",
    img: "https://i.imgur.com/3G4OYQP.png",
    url: "https://www.gogo.com.ar/",
    tecnologias: ["Next.js", "APIs", "Sass", "Git", "Vercel"],
  },
  {
    titulo: "Catálogos y herramientas comerciales",
    desc: "Solución para catálogos digitales, descripciones, imágenes y pedidos por WhatsApp, pensada para equipos que necesitan vender mejor sin sumar fricción operativa.",
    img: "https://i.imgur.com/yo6JNyT.png",
    url: "https://www.myshop.com.ar/",
    tecnologias: ["Next.js", "APIs", "Sass", "Git", "Vercel"],
  },
];

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const { allowHoverAnimations } = useAnimationSettings();

  useEffect(() => {
    startTransition(() => {
      setItems(proyectos.slice(0, 2));
    });
  }, []);

  return (
    <section className="portfolio-section w-full bg-[#F8F2EA]">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 text-center md:mb-14">
          <h3
            className="section-title tracking-tight"
            style={{ color: VIOLETA }}
          >
            Casos destacados
          </h3>
          <div
            className="mt-3 h-[3px] w-24 mx-auto rounded-full"
            style={{
              background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
            }}
          />
        </div>

        <div className="flex flex-col divide-y divide-[#697B681A]">
          {items.map((p, i) => (
            <React.Fragment key={p.titulo}>
              <NuevoItem {...p} />
              {i < items.length - 1 && (
                <div
                  className="h-[2px] w-3/4 mx-auto my-8 rounded-full"
                  style={{
                    background: `linear-gradient(90deg, transparent, ${ROSA}, transparent)`,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            onClick={() => {
              startTransition(() => {
                setItems((prev) =>
                  prev.length === proyectos.length
                    ? proyectos.slice(0, 2)
                    : proyectos,
                );
              });
            }}
            className={`motion-gpu inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white transition-all ${
              allowHoverAnimations ? "hover:scale-[1.03]" : ""
            }`}
            style={{
              background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
            }}
          >
            {items.length === proyectos.length ? "Ver menos" : "Ver más"}
            <Iconify
              icon={
                items.length === proyectos.length
                  ? "mdi:chevron-up-circle-outline"
                  : "mdi:chevron-down-circle-outline"
              }
              width={22}
              height={22}
            />
          </button>
        </div>
      </div>
    </section>
  );
}

